export const logo = `
  ████████╗██╗  ██╗██████╗ ███████╗ █████╗ ██████╗      ██████╗██████╗ ███╗   ███╗
  ╚══██╔══╝██║  ██║██╔══██╗██╔════╝██╔══██╗██╔══██╗    ██╔════╝██╔══██╗████╗ ████║
     ██║   ███████║██████╔╝█████╗  ███████║██║  ██║    ██║     ██████╔╝██╔████╔██║
     ██║   ██╔══██║██╔══██╗██╔══╝  ██╔══██║██║  ██║    ██║     ██╔══██╗██║╚██╔╝██║
     ██║   ██║  ██║██║  ██║███████╗██║  ██║██████╔╝██╗ ╚██████╗██║  ██║██║ ╚═╝ ██║
     ╚═╝   ╚═╝  ╚═╝╚═╝  ╚═╝╚══════╝╚═╝  ╚═╝╚═════╝ ╚═╝  ╚═════╝╚═╝  ╚═╝╚═╝     ╚═╝
`;
